/* DVR - molde flutuante no card. Versao enxuta para caber no envio. */
(function () {
'use strict';
var CFG = window.DVR_VITRINE;
if (!CFG || !CFG.artes) return;
var ARTE = {};
CFG.artes.forEach(function (p) { if (p && p[0] && p[1]) ARTE[p[0]] = p[1]; });
if (!Object.keys(ARTE).length) return;
var CAIXA = {
uni: {
Frente: { v: 'frente', L: 35.000, T: 32.037, W: 30.000, H: 36.852 },
Peito:  { v: 'frente', L: 55.556, T: 29.167, W: 13.704, H: 16.759 },
Costas: { v: 'costas', L: 35.278, T: 27.037, W: 29.815, H: 36.481 }
},
bab: {
Frente: { v: 'frente', L: 37.593, T: 32.222, W: 24.815, H: 30.556 },
Peito:  { v: 'frente', L: 54.352, T: 32.037, W: 11.574, H: 14.259 },
Costas: { v: 'costas', L: 38.163, T: 25.719, W: 23.969, H: 29.514 }
}
};
var CORES = [
{ k: 'branco',   n: 'Branco',       hex: '#f3f1ec', escura: false },
{ k: 'bege',     n: 'Bege',         hex: '#d9cbb3', escura: false },
{ k: 'rosa',     n: 'Rosa',         hex: '#e8b9c4', escura: false },
{ k: 'cinza',    n: 'Cinza mescla', hex: '#9d9d99', escura: false },
{ k: 'verde',    n: 'Verde',        hex: '#4f6b4a', escura: true  },
{ k: 'vermelho', n: 'Vermelho',     hex: '#a32b2b', escura: true  },
{ k: 'marrom',   n: 'Marrom',       hex: '#6b4a33', escura: true  },
{ k: 'roxo',     n: 'Roxo',         hex: '#5b4470', escura: true  },
{ k: 'preto',    n: 'Preto',        hex: '#1b1b1b', escura: true  }
];
var ONDE = { Frente: 'na frente', Peito: 'no peito', Costas: 'nas costas' };
var AJUSTE = {
'camisa-tres-olhares': 0.72
};
function escalaDe(chave) {
return AJUSTE[chave] || 1;
}
var CHAVE = 'dvr:vitrine';
var st = { mod: 'uni', loc: 'Frente', cor: 'branco' };
try {
var salvo = JSON.parse(localStorage.getItem(CHAVE) || 'null');
if (salvo && salvo.cor && CAIXA[salvo.mod] && CAIXA[salvo.mod][salvo.loc]) st = salvo;
} catch (e) {}
function guarda() { try { localStorage.setItem(CHAVE, JSON.stringify(st)); } catch (e) {} }
function corAtual() {
for (var i = 0; i < CORES.length; i++) if (CORES[i].k === st.cor) return CORES[i];
return CORES[0];
}
function baseUrl() {
var cx = CAIXA[st.mod][st.loc];
return CFG.bases + st.mod + '-' + st.cor + '-' + cx.v + '.webp?v=' + CFG.v + '&width=520';
}
var TOM = {};
var CACHE = 'dvr:tons';
var guardados = {};
try { guardados = JSON.parse(localStorage.getItem(CACHE) || '{}') || {}; } catch (e) { guardados = {}; }
function salva(url, c) {
try {
guardados[url] = {
b: c.box ? [c.box.x, c.box.y, c.box.w, c.box.h] : null,
f: c.fina ? 1 : 0,
e: c.clara ? 1 : 0
};
var ks = Object.keys(guardados);
var sobra = ks.length - 150;
for (var i = 0; i < sobra; i++) delete guardados[ks[i]];
localStorage.setItem(CACHE, JSON.stringify(guardados));
} catch (e) {}
}
function mede(url, cb) {
var c = TOM[url];
if (c && c.pronto) { cb(c); return; }
if (c) { c.fila.push(cb); return; }
c = TOM[url] = { pronto: false, fila: [cb] };
function fecha() { c.pronto = true; c.fila.forEach(function (f) { f(c); }); c.fila = []; }
var g = guardados[url];
if (g) {
c.box = g.b ? { x: g.b[0], y: g.b[1], w: g.b[2], h: g.b[3] } : null;
c.fina = !!g.f; c.clara = !!g.e;
fecha();
return;
}
var im = new Image();
im.crossOrigin = 'anonymous';
im.onload = function () {
var N = 600;
try {
var cv = document.createElement('canvas'); cv.width = N; cv.height = N;
var x = cv.getContext('2d', { willReadFrequently: true });
x.drawImage(im, 0, 0, N, N);
var d = x.getImageData(0, 0, N, N).data;
var x0 = N, y0 = N, x1 = 0, y1 = 0, n = 0, L = 0, op = 0, m = 0, S = 0;
for (var i = 0; i < d.length; i += 4) {
var al = d[i + 3], r = d[i], g = d[i + 1], b = d[i + 2];
if (al > 30) {
var q = i / 4, px = q % N, py = (q / N) | 0;
if (px < x0) x0 = px; if (px > x1) x1 = px;
if (py < y0) y0 = py; if (py > y1) y1 = py;
L += 0.2126 * r + 0.7152 * g + 0.0722 * b; n++;
if (al > 240) op++;
}
if (al > 128) { m++; S += Math.max(r, g, b) - Math.min(r, g, b); }
}
if (n > 20 && x1 >= x0 && y1 >= y0) {
c.box = { x: x0 / N, y: y0 / N, w: (x1 - x0 + 1) / N, h: (y1 - y0 + 1) / N };
var lum = L / n, area = Math.max((x1 - x0 + 1) * (y1 - y0 + 1), 1);
var sol = op / area, sat = m ? S / m : 255;
var traco = sol < 0.20 && sat < 18;
c.fina = traco && lum < 140;
c.clara = traco && lum > 150;
} else { c.box = null; c.fina = false; c.clara = false; }
} catch (e) { c.box = null; c.fina = false; c.clara = false; }
salva(url, c);
fecha();
};
im.onerror = function () { c.box = null; c.fina = false; c.clara = false; fecha(); };
im.src = url;
}
function poe(palco, base, a, cx, tom, escala) {
if (!base.naturalWidth) return;
var rb = base.getBoundingClientRect(), rp = palco.getBoundingClientRect();
if (!rb.width || !rp.width) return;
var ox = rb.left - rp.left, oy = rb.top - rp.top;
var cw = rb.width * cx.W / 100, ch = rb.height * cx.H / 100;
var cl = ox + rb.width * cx.L / 100, ct = oy + rb.height * cx.T / 100;
var b = tom && tom.box;
if (!b || !a.naturalWidth) {
a.style.left = cl + 'px'; a.style.top = ct + 'px';
a.style.width = cw + 'px'; a.style.height = ch + 'px';
a.style.objectPosition = 'top center';
return;
}
a.style.objectPosition = '';
var aspD = (b.w * a.naturalWidth) / (b.h * a.naturalHeight), dw, dh;
if (aspD > cw / ch) { dw = cw; dh = cw / aspD; } else { dh = ch; dw = ch * aspD; }
if (escala && escala !== 1) { dw *= escala; dh *= escala; }
var iw = dw / b.w, ih = dh / b.h;
a.style.width = iw + 'px';
a.style.height = ih + 'px';
a.style.left = (cl + (cw - dw) / 2 - b.x * iw) + 'px';
a.style.top = (ct - b.y * ih) + 'px';
}
function css() {
if (document.getElementById('dvrv-css')) return;
var s = document.createElement('style');
s.id = 'dvrv-css';
s.textContent =
'.dvrv-cont{position:relative}' +
'.dvrv-cont > img{opacity:0}' +
'.dvrv-cont > a.contents{opacity:0}' +
'.dvrv-palco{position:absolute;inset:0;z-index:1;pointer-events:none;' +
'display:flex;align-items:center;justify-content:center}' +
'.dvrv-luz{position:absolute;inset:0;pointer-events:none;transition:opacity .3s ease;opacity:.94}' +
'.dvrv-chao{position:absolute;left:14%;right:14%;bottom:9%;height:9%;pointer-events:none;' +
'border-radius:50%;background:radial-gradient(50% 50% at 50% 50%,' +
'rgba(0,0,0,.5) 0%,rgba(0,0,0,0) 72%)}' +
'.dvrv-base{width:100%;height:auto;aspect-ratio:1/1;object-fit:contain;display:block;' +
'filter:drop-shadow(0 16px 22px rgba(0,0,0,.5))}' +
'.dvrv-arte{position:absolute;object-fit:contain;display:block}' +
'.dvrv-arte.inv{filter:brightness(0) invert(1)}' +
'.dvrv-arte.esc{filter:brightness(0)}' +
'.dvrv-barra{max-width:1180px;margin:0 auto;padding:9px 16px 10px;' +
'display:flex;flex-wrap:wrap;gap:14px 18px;align-items:flex-start;' +
'border-top:1px solid var(--dv-line,rgba(164,156,140,.22))}' +
'.dvrv-g{display:flex;flex-direction:column;gap:6px;min-width:0}' +
'.dvrv-rot{font-size:9.5px;letter-spacing:.16em;text-transform:uppercase;' +
'color:var(--dv-mut,#a49c8c);font-weight:600}' +
'.dvrv-ops{display:flex;flex-wrap:wrap;gap:6px;align-items:center}' +
'.dvrv-ops button{font:inherit;font-size:12px;line-height:1;padding:7px 13px;' +
'border-radius:20px;border:1px solid var(--dv-line,rgba(164,156,140,.22));' +
'background:transparent;color:var(--dv-txt,#f3efe6);cursor:pointer;opacity:.8}' +
'.dvrv-ops button:hover{opacity:1}' +
'.dvrv-ops button.on{opacity:1;font-weight:700;' +
'background:var(--dv-accent,#d4b36a);border-color:var(--dv-accent,#d4b36a);color:#0d0c0a}' +
'.dvrv-cor{width:24px;height:24px;padding:0;border-radius:50%;opacity:.9}' +
'.dvrv-cor.on{opacity:1;box-shadow:0 0 0 2px var(--dv-accent,#d4b36a)}' +
'.dvrv-dica{flex-basis:100%;margin:0;font-size:11px;line-height:1.4;' +
'color:var(--dv-mut,#a49c8c)}' +
'.dvrv-curta{display:none}' +
'@media (max-width:699px){' +
'.dv-filtro-ttl{padding-bottom:8px}' +
'.dvrv-barra{display:grid;grid-template-columns:max-content 1fr;' +
'gap:6px 10px;align-items:center;padding:8px 16px}' +
'.dvrv-g{display:contents}' +
'.dvrv-rot{font-size:9px;letter-spacing:.08em;line-height:1.2}' +
'.dvrv-ops{gap:5px}' +
'.dvrv-ops button{font-size:11px;padding:5px 10px}' +
'.dvrv-cor{width:19px;height:19px;padding:0}' +
'.dvrv-dica{grid-column:1 / -1;font-size:9.5px;line-height:1.3}' +
'.dvrv-longa{display:none}' +
'.dvrv-curta{display:inline}' +
'}' +
'@media (min-width:700px){.dvrv-ops button{font-size:12.5px}}';
document.head.appendChild(s);
}
function cssCabecalho() {
var f = document.querySelector('.dv-filtro.dv-fixo');
if (!f) return;
if (f.style.zIndex !== '1') f.style.zIndex = '1';
if (document.getElementById('dvrv-css-topo')) return;
var s = document.createElement('style');
s.id = 'dvrv-css-topo';
s.textContent = '#header-group{position:relative;z-index:60}';
document.head.appendChild(s);
}
function tomDoTopo() {
if (document.getElementById('dvrv-css-tom')) return;
if (casados < 2) return;
if (!document.querySelector('.dv-filtro')) return;
var s = document.createElement('style');
s.id = 'dvrv-css-tom';
s.textContent =
'.dv-row--txt{flex-wrap:nowrap !important;overflow-x:auto !important;' +
'scroll-snap-type:x proximity;padding-bottom:12px}' +
'.dv-row--txt .dv-chip{scroll-snap-align:start}' +
'.dv-row--txt.dvrv-corre.dvrv-ini{' +
'-webkit-mask-image:linear-gradient(90deg,#000 calc(100% - 56px),transparent);' +
'mask-image:linear-gradient(90deg,#000 calc(100% - 56px),transparent)}' +
'.dv-row--txt.dvrv-corre.dvrv-fim{' +
'-webkit-mask-image:linear-gradient(90deg,transparent,#000 56px);' +
'mask-image:linear-gradient(90deg,transparent,#000 56px)}' +
'.dv-row--txt.dvrv-corre:not(.dvrv-ini):not(.dvrv-fim){' +
'-webkit-mask-image:linear-gradient(90deg,transparent,#000 56px,#000 calc(100% - 56px),transparent);' +
'mask-image:linear-gradient(90deg,transparent,#000 56px,#000 calc(100% - 56px),transparent)}' +
'a.dv-card{position:relative;z-index:0}' +
'.dv-ph{background:transparent !important}' +
'.dv-card{background:transparent !important;border-color:transparent !important;' +
'overflow:visible !important;transition:transform .3s ease !important}' +
'.dv-card:hover{background:transparent !important;border-color:transparent !important;' +
'transform:translateY(-3px) !important}' +
'.dv-card:hover .dvrv-luz{opacity:1}' +
'.dv-info{padding:21px 3px 0 !important;' +
'background-image:linear-gradient(rgba(212,179,106,.5),rgba(212,179,106,.5));' +
'background-repeat:no-repeat;background-size:26px 1px;background-position:3px 10px}' +
'.dv-nome{font-family:Fraunces,Georgia,serif !important;font-size:13.5px !important;' +
'line-height:1.28 !important;font-weight:500 !important}' +
'.dv-hero::after{display:none}' +
'.dv-hero{position:relative;overflow:hidden;background:' +
'radial-gradient(78% 150% at 26% 22%,rgba(226,196,124,.30) 0%,' +
'rgba(110,140,74,.28) 38%,rgba(0,0,0,0) 72%) !important}' +
'.dv-hero-in{position:relative;z-index:2}' +
'.dv-hero h1{font-family:Fraunces,Georgia,serif !important;font-weight:500 !important;' +
'letter-spacing:-.01em}' +
'.dv-filtro.dv-fixo{background:rgba(35,45,27,.92) !important;' +
'-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px)}' +
'.dvrv-esp{position:absolute;inset:0;pointer-events:none;z-index:-1}' +
'.dv-hero{min-height:0 !important}' +
'.dv-hero-in{padding:16px 16px 6px !important}' +
'@media (min-width:700px){.dv-hero-in{padding:24px 16px 8px !important}}';
document.head.appendChild(s);
var grade = document.querySelector('.dv-grid');
var raiz = grade ? grade.parentElement : null;
if (raiz && !raiz.dvrvMata) {
raiz.dvrvMata = 1;
raiz.style.position = 'relative';
raiz.style.zIndex = '0';
raiz.style.isolation = 'isolate';
raiz.style.background =
'radial-gradient(130% 56% at 50% -6%,rgba(226,196,124,.308) 0%,' +
'rgba(96,124,66,.386) 30%,rgba(0,0,0,0) 68%),' +
'#2a3620';
raiz.style.backgroundRepeat = 'no-repeat, repeat';
raiz.style.backgroundSize = '100% 900px, auto';
fonteDisplay();
esporos(raiz);
}
}
function fonteDisplay() {
if (document.getElementById('dvrv-fonte')) return;
var l = document.createElement('link');
l.id = 'dvrv-fonte';
l.rel = 'stylesheet';
l.href = 'https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,400;9..144,500;9..144,600&display=swap';
document.head.appendChild(l);
}
function esporos(raiz) {
if (window.innerWidth < 760) return;
if (window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
if (raiz.querySelector('.dvrv-esp')) return;
var cv = document.createElement('canvas');
cv.className = 'dvrv-esp';
raiz.insertBefore(cv, raiz.firstChild);
var cx = cv.getContext('2d'), P = [];
function dim() {
var r = raiz.getBoundingClientRect();
cv.width = r.width;
cv.height = Math.min(r.height, 2400);
}
function seed() {
P = [];
var n = Math.min(80, Math.round(cv.width / 15));
for (var i = 0; i < n; i++) {
P.push({ x: Math.random() * cv.width, y: Math.random() * cv.height,
r: Math.random() * 1.7 + 0.5, v: Math.random() * 0.20 + 0.05,
a: Math.random() * 0.28 + 0.06, d: Math.random() * 6.283 });
}
}
function tick() {
cx.clearRect(0, 0, cv.width, cv.height);
for (var i = 0; i < P.length; i++) {
var p = P[i];
p.y -= p.v; p.d += 0.008; p.x += Math.sin(p.d) * 0.2;
if (p.y < -6) { p.y = cv.height + 6; p.x = Math.random() * cv.width; }
cx.beginPath(); cx.arc(p.x, p.y, p.r, 0, 6.283);
cx.fillStyle = 'rgba(216,206,150,' + p.a + ')';
cx.fill();
}
requestAnimationFrame(tick);
}
setTimeout(function () { dim(); seed(); tick(); }, 90);
var t;
window.addEventListener('resize', function () {
clearTimeout(t); t = setTimeout(function () { dim(); seed(); }, 160);
});
}
var pecas = [];
function handleDe(a) {
var h = a.getAttribute('href') || '';
var i = h.indexOf('/products/');
if (i < 0) return '';
var resto = h.slice(i + 10);
resto = resto.split('?')[0];
resto = resto.split('#')[0];
return resto.split('/')[0];
}
function monta(cont, chave) {
var url = ARTE[chave];
if (!url || cont.dvrvPronto) return;
cont.dvrvPronto = 1;
var palco = document.createElement('div');
palco.className = 'dvrv-palco';
var b = document.createElement('img');
b.className = 'dvrv-base'; b.alt = ''; b.decoding = 'async';
var a = document.createElement('img');
a.className = 'dvrv-arte'; a.alt = ''; a.decoding = 'async';
var luz = document.createElement('span'); luz.className = 'dvrv-luz';
var chao = document.createElement('span'); chao.className = 'dvrv-chao';
palco.appendChild(luz); palco.appendChild(chao);
palco.appendChild(b); palco.appendChild(a);
cont.appendChild(palco);
cont.classList.add('dvrv-cont');
var cartao = cont.closest ? cont.closest('a.dv-card') : null;
var selo = cartao ? cartao.querySelector('.dv-canto') : null;
if (selo && !selo.dvrvOriginal) selo.dvrvOriginal = selo.textContent;
var it = { palco: palco, base: b, arte: a, url: url, selo: selo, luz: luz, chave: chave };
pecas.push(it);
b.onload = function () { pinta1(it); };
a.onload = function () { pinta1(it); };
pinta1(it);
mede(url, function () { pinta1(it); });
}
function luzDaVez() {
return corAtual().escura
? 'radial-gradient(50% 42% at 50% 45%,rgba(230,208,150,.42) 0%,' +
'rgba(150,168,98,.26) 40%,rgba(0,0,0,0) 78%)'
: 'radial-gradient(44% 36% at 50% 46%,rgba(150,176,120,.14) 0%,' +
'rgba(86,110,64,.10) 44%,rgba(0,0,0,0) 78%)';
}
function pinta1(it) {
if (it.luz) it.luz.style.background = luzDaVez();
var cx = CAIXA[st.mod][st.loc];
if (it.selo) it.selo.textContent = st.mod === 'bab' ? 'BABY LOOK' : (it.selo.dvrvOriginal || 'UNISSEX');
var u = baseUrl();
if (it.base.getAttribute('src') !== u) { it.base.removeAttribute('srcset'); it.base.src = u; }
if (it.arte.getAttribute('src') !== it.url) { it.arte.removeAttribute('srcset'); it.arte.src = it.url; }
var t = TOM[it.url];
var escura = corAtual().escura;
if (t && t.pronto) {
it.arte.classList.toggle('inv', escura && t.fina === true);
it.arte.classList.toggle('esc', !escura && t.clara === true);
}
poe(it.palco, it.base, it.arte, cx, t && t.pronto ? t : null, escalaDe(it.chave));
}
function pintaTudo() { pecas.forEach(pinta1); }
var fila = [];
var casados = 0;
function agendaCarta(cont, chave) {
if (!chave || !ARTE[chave] || cont.dvrvVisto) return;
cont.dvrvVisto = 1;
casados++;
fila.push({ cont: cont, chave: chave });
}
function liberaPerto() {
if (!fila.length) return;
var limite = (window.innerHeight || 800) + 700;
var restam = [];
for (var i = 0; i < fila.length; i++) {
var f = fila[i];
var r = f.cont.getBoundingClientRect();
var visivel = r.bottom > -700 && r.top < limite;
var semTamanho = r.width === 0 && r.height === 0;
if (visivel && !semTamanho) monta(f.cont, f.chave);
else restam.push(f);
}
fila = restam;
}
function varre() {
var i, n;
var dv = document.querySelectorAll('a.dv-card');
for (i = 0, n = dv.length; i < n; i++) {
var ph = dv[i].querySelector('.dv-ph');
if (ph) agendaCarta(ph, handleDe(dv[i]));
}
var gg = document.querySelectorAll('.card-gallery[data-product-id]');
for (i = 0, n = gg.length; i < n; i++) {
agendaCarta(gg[i], gg[i].getAttribute('data-product-id'));
}
}
function fraseTodas() {
var chips = document.querySelectorAll('.dv-chip[data-dv-key]');
for (var i = 0; i < chips.length; i++) {
var c = chips[i];
if (c.getAttribute('data-dv-key')) continue;
if (c.dvrvFrase) return;
c.dvrvFrase = 1;
var texto = 'Desenho próprio, impresso um a um.';
c.setAttribute('data-dv-frase', texto);
if (c.getAttribute('aria-pressed') === 'true') {
var box = document.querySelector('[data-dv-frase-box]');
if (box && !box.textContent) box.textContent = texto;
}
return;
}
}
function pintaTrilho(fila) {
var corre = fila.scrollWidth - fila.clientWidth > 4;
fila.classList.toggle('dvrv-corre', corre);
fila.classList.toggle('dvrv-ini', fila.scrollLeft <= 4);
fila.classList.toggle('dvrv-fim', fila.scrollLeft + fila.clientWidth >= fila.scrollWidth - 4);
}
function trilhoEstilos() {
var fila = document.querySelector('.dv-row--txt');
if (!fila) return;
if (!fila.dvrvTrilho) {
fila.dvrvTrilho = 1;
fila.addEventListener('scroll', function () { pintaTrilho(fila); }, { passive: true });
window.addEventListener('resize', function () { pintaTrilho(fila); });
}
pintaTrilho(fila);
}
function rodizio() {
var grade = document.querySelector('.dv-grid');
if (!grade || grade.dvrvRodizio) return;
var cartoes = grade.querySelectorAll('a.dv-card');
if (cartoes.length < 6) return;
grade.dvrvRodizio = 1;
var ordem = [], grupos = {}, i;
for (i = 0; i < cartoes.length; i++) {
var chaves = (cartoes[i].getAttribute('data-dv-keys') || '').split(' ');
var chave = '';
for (var j = 0; j < chaves.length; j++) {
if (chaves[j]) { chave = chaves[j]; break; }
}
if (!grupos[chave]) { grupos[chave] = []; ordem.push(chave); }
grupos[chave].push(cartoes[i]);
}
if (ordem.length < 2) return;
var fila = [], sobrou = true, volta = 0;
while (sobrou) {
sobrou = false;
for (i = 0; i < ordem.length; i++) {
var g = grupos[ordem[i]];
if (volta < g.length) { fila.push(g[volta]); sobrou = true; }
}
volta++;
if (volta > 400) break;
}
var pedaco = document.createDocumentFragment();
for (i = 0; i < fila.length; i++) pedaco.appendChild(fila[i]);
grade.insertBefore(pedaco, grade.firstChild);
}
var prom = null, promOrig = null;
function ajustaPromessa() {
if (!prom) {
prom = document.querySelector('.dv-prom b');
if (prom) promOrig = prom.textContent;
}
if (!prom || !promOrig) return;
var alvo = st.mod === 'bab' ? promOrig.split('Unissex').join('Baby look') : promOrig;
if (prom.textContent !== alvo) prom.textContent = alvo;
}
var elDica = null, elLonga = null, elCurta = null;
function legenda() {
if (!elDica) return;
var combo = (st.mod === 'uni' ? 'unissex' : 'baby look') +
', estampa ' + ONDE[st.loc] + ', em ' + corAtual().n.toLowerCase();
elLonga.textContent = 'Malha premium, do P ao GG. A cor e o local da estampa não mudam o preço. ' +
'Prévia: ' + combo + '.';
elCurta.textContent = 'Malha premium, do P ao GG. Prévia: ' + combo + '.';
ajustaPromessa();
}
function grupo(longo, curto) {
var g = document.createElement('div'); g.className = 'dvrv-g';
var r = document.createElement('span'); r.className = 'dvrv-rot';
var a = document.createElement('span'); a.className = 'dvrv-longa'; a.textContent = longo;
var b = document.createElement('span'); b.className = 'dvrv-curta'; b.textContent = curto;
r.appendChild(a); r.appendChild(b);
var o = document.createElement('div'); o.className = 'dvrv-ops';
g.appendChild(r); g.appendChild(o); g.ops = o;
return g;
}
function liga(b, chave, valor) {
b.onclick = function () {
st[chave] = valor; guarda();
var pai = b.parentNode;
for (var i = 0; i < pai.children.length; i++) pai.children[i].classList.remove('on');
b.classList.add('on');
pintaTudo(); legenda();
};
}
function montaBarra() {
if (document.querySelector('.dvrv-barra')) return;
if (casados < 2) return;
var grade = document.querySelector('.dv-grid');
if (!grade || !grade.parentNode) return;
var barra = document.createElement('div');
barra.className = 'dvrv-barra';
var gm = grupo('Você escolhe a modelagem', 'Modelagem');
[['Unissex', 'uni'], ['Baby look', 'bab']].forEach(function (par) {
var b = document.createElement('button');
b.type = 'button'; b.textContent = par[0];
if (st.mod === par[1]) b.className = 'on';
liga(b, 'mod', par[1]);
gm.ops.appendChild(b);
});
barra.appendChild(gm);
var gl = grupo('Você escolhe o local da estampa', 'Estampa');
['Frente', 'Peito', 'Costas'].forEach(function (l) {
var b = document.createElement('button');
b.type = 'button'; b.textContent = l;
if (st.loc === l) b.className = 'on';
liga(b, 'loc', l);
gl.ops.appendChild(b);
});
barra.appendChild(gl);
var gc = grupo('Você escolhe a cor', 'Cor');
CORES.forEach(function (c) {
var b = document.createElement('button');
b.type = 'button';
b.className = 'dvrv-cor' + (st.cor === c.k ? ' on' : '');
b.style.background = c.hex;
b.title = c.n;
b.setAttribute('aria-label', c.n);
liga(b, 'cor', c.k);
gc.ops.appendChild(b);
});
barra.appendChild(gc);
elDica = document.createElement('p');
elDica.className = 'dvrv-dica';
elLonga = document.createElement('span');
elLonga.className = 'dvrv-longa';
elCurta = document.createElement('span');
elCurta.className = 'dvrv-curta';
elDica.appendChild(elLonga);
elDica.appendChild(elCurta);
barra.appendChild(elDica);
legenda();
var filtro = document.querySelector('.dv-filtro');
if (filtro) filtro.appendChild(barra);
else grade.parentNode.insertBefore(barra, grade);
}
var t1, mutando = false;
function ciclo() {
mutando = true;
css(); cssCabecalho(); varre(); tomDoTopo(); liberaPerto();
rodizio(); montaBarra(); fraseTodas(); trilhoEstilos(); ajustaPromessa();
setTimeout(function () { mutando = false; }, 0);
}
function agenda() {
if (mutando) return;
clearTimeout(t1);
t1 = setTimeout(ciclo, 250);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ciclo);
else ciclo();
window.addEventListener('load', ciclo);
setTimeout(ciclo, 500);
setTimeout(ciclo, 1600);
new MutationObserver(agenda).observe(document.documentElement, { childList: true, subtree: true });
var t2;
window.addEventListener('resize', function () {
clearTimeout(t2); t2 = setTimeout(function () { liberaPerto(); pintaTudo(); }, 140);
});
var rolando = false;
window.addEventListener('scroll', function () {
if (rolando) return;
rolando = true;
setTimeout(function () { rolando = false; liberaPerto(); }, 150);
}, { passive: true });
})();
